import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import React, { useState } from "react";

const columns = [
  {
    accessor: "so",
    header: "Sales Order number",
    cell: (row) => <>{row?.so?.so_number}</>,
  },
  {
    accessor: "item",
    header: "Item Code",
    cell: (row) => <>{row?.item?.item_code}</>,
  },
  {
    accessor: "work_order",
    header: "Work Order ID",
    cell: (row) => <>{row?.wo?.work_order_code}</>,
  },
  {
    accessor: "movement_type",
    header: "Movement Type",
  },
  {
    accessor: "direction",
    header: "Direction",
  },
  {
    accessor: "quantity",
    header: "Quantity",
  },
  {
    accessor: "source_bucket",
    header: "Source",
  },
  {
    accessor: "target_bucket",
    header: "Target",
  },
  {
    accessor: "source_document_type",
    header: "Document Type",
  },
  {
    accessor: "source_document_id",
    header: "Document ID",
  },
  {
    accessor: "qc_approval",
    header: "QC Approval",
  },
  {
    accessor: "ledger_status",
    header: "Ledger Status",
  }
];

const StockTransaction = () => {
  const [stockEntries, setStockEntries] = useState(5);
  const [stockPageIndex, setStockPageIndex] = useState(0);
  const [search, setSearch] = useState("");

  const { useFetch } = useAPIQuery({
    key: "stock-transaction",
    endpoint: "/api/stock-transaction/",
  });

  const { data, isLoading } = useFetch({
    params: {
      entries: stockEntries,
      page_no: stockPageIndex + 1,
      event: search ? search : undefined,
    },
    abortOnNewRequest: true,
    refetchOnWindowFocus: false,
    staleTime : 1000 * 60 * 3,
    retry : 3,
    keepPlaceholder : true,
    refetchOnReconnect : true
  });

  const handleGlobalFilterChange = (value) => {
    console.log(value);
    setSearch(value);
  };

  const handlePagination = (value) => {
    console.log(value);
    setStockPageIndex(value.pageIndex);
    setStockEntries(value.pageSize);
  };

  return (
    <>
      <div className="nk-block-head nk-block-head-sm">
        <div className="nk-block-between">
          <div className="nk-block-head-content d-flex">
            <h3 className="nk-block-title page-title">Stock Transaction</h3>
            {isLoading ? (
              <div className="spinner-border text-primary ms-2" role="status">
                <span className="sr-only"></span>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      <Table
        data={data ? data?.results.data : []}
        columns={columns}
        pagination
        pageIndex={stockPageIndex}
        pageSize={stockEntries}
        rowCount={data ? data.count : 0}
        globalSearch
        editRows={false}
        deleteRows={false}
        filterModal={false}
        selectRows={false}
        onGlobalFilterChange={handleGlobalFilterChange}
        onPaginationChange={handlePagination}
      />
    </>
  );
};

export default StockTransaction;
